<template>
    <div id="instagram-v2-channels">
        <AppBreadCrumb :paths="[{ title: 'Instagram V2 (Instagram Login)' }]" :select="true"></AppBreadCrumb>
        <div style="background-color: #ffffff" class="d-flex right-page">
            <div class="ml-3 mt-3" style="flex: 0 0 100%">
                <div class="big-title">Instagram V2 - Instagram Login</div>
                <div class="channels">
                    <div
                        class="story channel-add"
                        @click="$feature.beforeCreateIntegrationChannel(createChannel, 'instagram-v2')"
                    >
                        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%; gap: 10px;">
                            <a-icon type="plus-circle" theme="filled" style="font-size: 30px" />
                            <span class="text-large font-weight-bolder mt-2" style="font-size: 20px; letter-spacing: 2px">
                                {{ $t("whatsappChannel.addChannel") }}
                            </span>
                        </div>
                    </div>
                    <div
                        class="channel-item"
                        :class="{ disabled: !isChannelAccessible(channel) }"
                        v-for="(channel, index) in channels"
                        @click="() => isChannelAccessible(channel) && editChannel(channel)"
                        :key="index"
                    >
                        <div class="icon-container">
                            <InstagramIcon special-background-mode />
                        </div>
                        <div class="name-container">
                            <span class="name">{{ channel.name.toUpperCase() }}</span>
                            <span v-if="getInstagramUsername(channel)" class="username">
                                @{{ getInstagramUsername(channel) }}
                            </span>
                        </div>

                        <div v-if="getInstagramUsername(channel)" class="profile-button-container">
                            <button class="instagram-profile-btn" @click.stop="openInstagramProfile(channel)">
                                <i class="material-icons">open_in_new</i>
                                <span>Instagram Profili</span>
                            </button>
                        </div>

                        <div class="options">
                            <a-dropdown :trigger="['click']" placement="bottomRight">
                                <div class="icon-container ant-dropdown-link" @click="(e) => e.stopPropagation()">
                                    <span class="material-icons">more_horiz</span>
                                </div>
                                <template #overlay>
                                    <a-menu>
                                        <a-menu-item @click="copyChannelId(channel._id)" style="display:flex; gap: 5px">
                                            <i class="material-icons">content_copy</i>
                                            <span>Channel ID Kopyala</span>
                                        </a-menu-item>
                                        <a-menu-item>
                                            <div class="icon-container" @click="showDeleteConfirmation(channel._id)">
                                                <md-icon style="margin-right: 10px">delete</md-icon>
                                                <span>{{ $t("chatbotv2.delete") }}</span>
                                            </div>
                                        </a-menu-item>
                                    </a-menu>
                                </template>
                            </a-dropdown>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Modal2
            title="Instagram ile Bağlan"
            class-name="new-instagram-v2-channel"
            :showFooter="false"
            @cancel="showCreateForm = false"
            v-if="showCreateForm"
        >
            <CreateInstagramV2Channel @cancel="showCreateForm = false" @ok="showCreateForm = false" />
        </Modal2>

        <a-modal
            :visible="deleteModal"
            icon="exclamation-circle"
            title="Instagram V2 Entegrasyonu"
            @cancel="deleteModal = false"
        >
            <p>{{ $t("message.deleteInstaChannelInfo") }}</p>
            <template #footer>
                <a-button key="back" @click="deleteModal = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deleteInstagramV2Channel">
                    {{ $t("chatbotv2.delete") }}
                </a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import _ from "lodash";
import CreateInstagramV2Channel from "./CreateInstagramV2Channel.vue";
import Modal2 from "../../../../components/common/Modal2.vue";
import AppBreadCrumb from "../../../../components/common/AppBreadCrumb.vue";
import InstagramIcon from "../../Chatbot/pages/integrations/svg/InstagramIcon.vue";

export default {
    name: "InstagramV2Channels",
    components: {
        InstagramIcon,
        CreateInstagramV2Channel,
        Modal2,
        AppBreadCrumb,
    },
    data() {
        return {
            deleteModal: false,
            showCreateForm: false,
            updatingChannel: null,
            deleteChannelId: null,
        };
    },
    computed: {
        ...mapState({
            channelCount: (state) => state.channel.channels.filter((x) => ["instagram", "instagram-v2"].includes(x.type)).length,
            instagramChannelCount: (state) => state.site.features?.maxInstagramChannel || 0,
            isAdmin: (state) => state.auth.adminUser !== null,
            user: (state) => state.auth.user,
            allChannels: (state) => state.channel.channels,
        }),
        channels() {
            return this.allChannels.filter((x) => x.type === "instagram-v2" && !x.isDeleted);
        },
    },
    methods: {
        ...mapGetters({
            isChannelVisibleForMe: "channel/isChannelVisibleForMe",
        }),
        ...mapActions({
            listChannels: "channel/listChannels",
            deleteChannel: "channel/deleteChannel",
        }),
        getInstagramUsername(channel) {
            return _.get(channel, "payload.page.instagram_business_account.username", null);
        },
        openInstagramProfile(channel) {
            const username = this.getInstagramUsername(channel);
            if (username) {
                window.open(`https://www.instagram.com/${username}`, "_blank");
            }
        },
        copyChannelId(channelId) {
            navigator.clipboard.writeText(channelId).then(() => {
                this.$message.success("Channel ID kopyalandı");
            }).catch(() => {
                this.$message.error("Channel ID kopyalanamadı");
            });
        },
        showDeleteConfirmation(id) {
            this.deleteModal = true;
            this.deleteChannelId = id;
        },
        createChannel() {
            this.showCreateForm = true;
        },
        deleteInstagramV2Channel() {
            this.deleteModal = false;
            this.deleteChannel(this.deleteChannelId);
        },
        editChannel(channel) {
            this.$router.push(`/integrations/instagram-v2/${channel._id}/detail`);
        },
        showInstagramPlans() {
            this.$router.push("/billing/plans/instagram");
        },
        isChannelAccessible(channel) {
            return this.isAdmin || _.get(this.user, "isOwner", false) || this.isChannelVisibleForMe(channel);
        },
    },
    mounted() {
        this.listChannels();
    },
    beforeDestroy() {},
    watch: {},
};
</script>

<style lang="scss" scoped>
#instagram-v2-channels {
    width: 100%;
    min-height: calc(100vh - 50px);
    background: var(--color-bg-default);
    .channel-item.disabled {
        opacity: 0.5;
        pointer-events: none;
    }

    .big-title {
        font-weight: bold;
        font-size: 1.5rem;
        margin: 1rem 0;
    }

    .channels {
        display: flex;
        align-items: flex-start;
        padding-bottom: 1rem;
        flex-wrap: wrap;
        gap: 1rem;

        .story {
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 280px;
            height: 260px;
            min-width: 250px;
            max-width: 250px;
            margin-top: 10px;

            &:hover {
                border: 1px solid #06a9f3;
            }

            .title {
                margin: 1rem 0;
                font-weight: bold;
            }

            .chatbot-btn {
                border: none;
                background: #fff;
                border-radius: 4px;
                padding: 4px 8px;
                margin: 0;
                min-height: 34px;
                min-width: 34px;
                color: #000;
                display: flex;
                align-items: center;
                box-shadow: none !important;
                text-shadow: none !important;

                span {
                    text-align: left;
                }
            }
        }

        .channel-item {
            position: relative;
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 280px;
            height: 260px;
            min-width: 250px;
            max-width: 250px;
            text-align: center;
            transition: 500ms;
            margin-top: 10px;
            display: flex;
            flex-direction: column;
            gap: 10px;

            .web-hook-title {
                word-break: break-all;
            }

            &:hover {
                border: 1px solid #06a9f3;

                span {
                    color: #06a9f3;
                }

                transform: translateY(-10px);
                box-shadow: -4px 22px 11px -5px rgba(0, 0, 0, 0.1);

                .options {
                    .icon-container {
                        i {
                            transform: rotate(360deg);
                            color: #06a9f3;
                        }
                    }
                }
            }

            .icon-container {
                width: 120px;
                height: 120px;
                display: flex;
                margin: 0 auto;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                overflow: hidden;
                position: relative;
                background: #fff;
                padding: 10px;

                svg {
                    width: 70px;
                    height: 70px;
                }
            }

            .name-container {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-top: 20px;
                gap: 5px;

                .name {
                    font-size: 1.2rem;
                    font-weight: 600;
                    color: #000;
                }

                .username {
                    font-size: 0.9rem;
                    font-weight: 400;
                    color: #666;
                }
            }

            .profile-button-container {
                display: flex;
                justify-content: center;
                margin-top: 15px;

                .instagram-profile-btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    padding: 8px 16px;
                    background: #1890ff;
                    color: #fff;
                    border: none;
                    border-radius: 4px;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.3s ease;

                    i {
                        font-size: 16px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #fff !important;
                    }

                    span {
                        line-height: 1;
                    }

                    &:hover {
                        background: #40a9ff;
                        transform: translateY(-2px);
                        box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
                        
                        i, span {
                            color: #fff;
                        }
                    }

                    &:active {
                        transform: translateY(0);
                    }
                }
            }

            .options {
                position: absolute;
                top: 10px;
                right: 10px;

                .icon-container {
                    width: auto;
                    height: auto;
                    background: transparent;
                    padding: 0;
                    margin: 0;
                    cursor: pointer;
                    transition: 200ms;

                    i {
                        font-size: 20px;
                        color: #000;
                        transition: 200ms;
                    }
                }
            }
        }

        .channel-add {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #006cff;
            border-color: #006cff;
            color: #fff;

            i {
                margin: 0;
            }
        }
    }
}
</style>
